import { motion } from "framer-motion"

import Technology from "../../molecules/Technology/Technology";
import CompanyName from "../../atoms/CompanyName/CompanyName"
import Constants from '../../../app/utils/constants'
import ChooseUs from "../../molecules/ChooseUs/ChooseUs";
import Industries from "../../molecules/Industries/Industries";
import Stats from "../../molecules/Stats/Stats";
import HeroSection from "../../organisms/HeroSection/HeroSection";
import Portfolio from "../../molecules/Portfolio/Portfolio";
import Message from "../../molecules/Message/Message";
import Questions from "../../molecules/Questions/Questions";
import ReadyToBuild from "../../molecules/ReadyToBuild/ReadyToBuild";
import Footer from "../../organisms/Footer/Footer";


const HomePage = () => {
  const { stats } = Constants;

  const fadeUp = {
    initial: { opacity: 0, y: 80 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: false, margin: "-100px" },
    transition: { duration: 0.7, ease: 'easeIn' as const }
  };

  return (
    <div className="relative min-h-screen text-white bg-[#0E0924] bg-linear-to-br from-[#05030f] via-[#0a0725] to-[#02010a] overflow-hidden">
      
      {/* <div className={leftSemiCircleClass} /> */}

      <div className="relative z-10">

        {/* Hero */}
        <HeroSection />
        <CompanyName />

        {/* Sections */}
        <motion.div {...fadeUp}><Stats stats={stats} /></motion.div>
        <motion.div {...fadeUp}><Technology /></motion.div>
        <motion.div {...fadeUp}><ChooseUs /></motion.div>

        {/* Industries */}
        <motion.div {...fadeUp}>
          <div className="relative">

            <div className="absolute top-0 left-0 w-full h-[3px] 
              bg-[linear-gradient(109.42deg,#745EF0_0%,rgba(116,94,240,0.03)_60%,rgba(116,94,240,0.03)_85%,#8379be_100%)]" />

            <Industries />

            <div className="absolute bottom-0 left-0 w-full h-[3px] 
              bg-[linear-gradient(109.42deg,#745EF0_0%,rgba(116,94,240,0.03)_40%,rgba(116,94,240,0.03)_60%,#745EF0_100%)]" />
          </div>
        </motion.div>

        <motion.div {...fadeUp}><Portfolio /></motion.div>
     
        {/* Message + Questions */}
        <motion.div {...fadeUp}>
          <div className="mb-10 mt-25  px-4 md:px-8 2xl:mx-20 xl:px-12">
            <div className="grid w-full text-center items-center justify-center grid-cols-1 gap-5 xl:min-h-[620px] 2xl:min-h-[710px] lg:grid-cols-[1fr_1fr] xl:grid-cols-[1fr_2fr]">
              <Message />
              <Questions />
            </div>
          </div>
        </motion.div>

        <motion.div {...fadeUp}><ReadyToBuild /></motion.div>
        <Footer />

      </div>
    </div>
  );
};

export default HomePage;
